<template>
    <div class="auth-page">

        <div class="auth-header">
            <h1 class="title is-1">App de Pedidos</h1>
            <p class="subtitle">Um sistema simples de pedidos criado pela <a href="https://www.cimsw.com.br">CIM
                Soluções Web</a> para ajudar a pequenas empresas a gerenciar seus pedidos</p>
        </div>

        <div v-if="action === 'create'">
            <AuthUserCreate/>
            <div class="auth-footer">
                <a role="button" class="button is-text is-rounded is-fullwidth" @click="action = 'login'"
                >Acessar minha conta</a
                >
            </div>
        </div>

        <div v-if="action === 'login'">
            <AuthUserLogin/>
            <div class="auth-footer">
                <a role="button" class="button is-text is-rounded is-fullwidth" @click="action = 'create'"
                >Criar uma conta</a
                >
            </div>
        </div>
    </div>
</template>

<script>
    import AuthUserCreate from "./AuthUserCreate";
    import AuthUserLogin from "./AuthUserLogin";

    export default {
        name: "auth-page",
        components: {AuthUserCreate, AuthUserLogin},

        data() {
            return {
                action: "create"
            };
        }
    };
</script>

<style lang="scss">
    @import '@/styles/config.sass';

    .auth-page {
        padding: 0 $conf-espaco;
        margin: 60px auto;
        max-width: 480px;

        .auth-header {
            margin-bottom: $conf-espaco;
            padding-bottom: $conf-espaco;
            border-bottom: 1px solid $border;

            .subtitle {
                font-size: $size-normal + 2;
                line-height: 1.5;
            }
        }
        
        form{
            button[type="submit"]{
                margin-top: ceil($conf-espaco-pequeno * 1.5);
            }
        }

        .auth-footer {
            border-top: 1px solid $border;
            padding-top: $conf-espaco;
            margin-top: $conf-espaco;
        }
    }
</style>
